// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FufUploader-modal-body-KyY {\n  width: 500px;\n}\n", "",{"version":3,"sources":["webpack://./src/Components/FufUploader/FufUploader.less"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ","sourcesContent":[".modal-body {\n    width: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-body": "FufUploader-modal-body-KyY"
};
export default ___CSS_LOADER_EXPORT___;
